import { setPageTop } from "./libs";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const pageTop = () => {
  const pageTop = document.querySelector('.js-pagetop');
  const footer = document.querySelector('#site-footer');

  var scroll_y = window.scrollY;

  if(scroll_y > 300) {
    if(!pageTop.classList.contains('is-active')) {
      pageTop.classList.add('is-active')
    }
  } else {
    pageTop.classList.remove('is-active')
  }

  window.addEventListener('scroll', (event) => {
    scroll_y = window.scrollY;

    if(scroll_y > 300) {
      if(!pageTop.classList.contains('is-active')) {
        pageTop.classList.add('is-active')
      }
    } else {
      pageTop.classList.remove('is-active')
    }
  });
  ScrollTrigger.create({
    id: "pageTop",
    trigger: footer,
    markers: false,
    start: "top bottom",
    onEnter: () => {
      pageTop.classList.add('is-bottom')
    },
    onLeaveBack: () => {
      pageTop.classList.remove('is-bottom')
    }
  });

  // 監視ターゲットの取得
  const targets = document.querySelectorAll('.entries-wrap, .members-list');

  // オブザーバーの作成
  const observer = new MutationObserver(records => {
    ScrollTrigger.getById("pageTop").kill();
    ScrollTrigger.create({
      id: "pageTop",
      trigger: footer,
      markers: false,
      start: "top bottom",
      onEnter: () => {
        pageTop.classList.add('is-bottom')
      },
      onLeaveBack: () => {
        pageTop.classList.remove('is-bottom')
      },
    });
  })

  targets.forEach((target) => {
    // 監視の開始
    observer.observe(target, {
      attributes: true,
      subtree: true
    })
  })

  setPageTop();
}

export default pageTop;